import Vue from 'vue';
import '../../utils/event'
import MonetizationService from '../../MyAccount/components/Monetization/MonetizationService'
import {ErrorModal} from '../../Modals/ErrorModal'
import './ExpertOpinionDialog'


export default Vue.component('monetization-documents', {
    props: ['token', 'monetizationId'],
    data() {
        return {
            expertOpinionDocuments: [],
        };
    },
    async created() {
        if (this.token) {
            await this.getExpertOpinionDocuments()
        }
    },
    methods: {
        async getExpertOpinionDocuments() {
            try {
                const response = await MonetizationService.getExpertOpinionsDocuments(this.monetizationId)
                this.expertOpinionDocuments = response
            } catch (e) {
                console.error('Cannot fetch expert opinion documents', e)
            }
        },
        async downloadExpertOpinionDocument(document) {
            try {
                const {data, headers} = await MonetizationService.downloadExpertOpinionDocument(document.item, document.expertOpinionId)
                const fileName = headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')
                const a = window.document.createElement('a')
                a.href = URL.createObjectURL(data)
                a.download = fileName
                a.click()
            } catch (e) {
                console.log(e)
                ErrorModal.show(this, this.$i18n.t(e.response && e.response.data['error'] ? `error.${e.response.data['error']}` : 'Něco se pokazilo'))
            }
        },
        openExpertOpinionDownloadDialog(expertOpinionId) {
            if (!this.token) {
                Event.fire('expertOpinionDocumentDialogOpen', expertOpinionId)
            }
        }
    }
});

